import { MultiFieldSet } from "../../../../../../components/utils/useFieldSet";
import {
  PublicJobSectionGraph,
  PublicOrgSelfIdQuestionNode,
} from "../../../../../graphql.types";

import { LoadingWrapper } from "@/components/loading-mask";
import {
  JobAppSelfIdQuestionAnswerRequest,
  useFetchOrgIsGovernmentContractor,
} from "modules/api-docs";
import { SelfIdQuestionFragment } from "../../../../components/self-apply-application-form-fragments/self-id-questions/self-id-questions";
import { SelfApplySectionContainer } from "../../../../components/self-apply-section-container";
import { GovtContractorSelfIdSection } from "./govt-contractor-self-identification/govt-contractor-self-identification";

export const SelfApplySelfIDAppSection = (props: {
  orgFriendlyName: string;
  fieldSet: MultiFieldSet<JobAppSelfIdQuestionAnswerRequest>;
  section: PublicJobSectionGraph;
  questions: PublicOrgSelfIdQuestionNode[];
}) => {
  const { fieldSet, section, questions } = props;

  const isGovtContractorResponse = useFetchOrgIsGovernmentContractor(
    {
      orgFriendlyName: props.orgFriendlyName,
    },
    {
      query: {
        enabled: !!props.orgFriendlyName,
      },
    },
  );

  if (
    isGovtContractorResponse.isLoading ||
    !isGovtContractorResponse.isSuccess
  ) {
    return (
      <LoadingWrapper
        loading
        loadingMessage="Loading Self ID Form Section"
        error
        errorMessage="Could not determine government contractor status."
      />
    );
  }

  const isGovtContractor = isGovtContractorResponse.data;
  if (isGovtContractor) {
    return (
      <GovtContractorSelfIdSection
        fieldSet={fieldSet}
        orgFriendlyName={props.orgFriendlyName}
        section={{
          name: "Self Identification Questions",
        }}
      />
    );
  }

  return questions?.some((q) => q?.enabled) ? (
    <SelfApplySectionContainer.Container
      key={section.id}
      description={
        questions?.find((question) => question?.selfIdType === "DESCRIPTION")
          ?.name
      }
      title={section.name}
      isRequired={section.isRequired}
    >
      <SelfApplySectionContainer.Content>
        <SelfIdQuestionFragment
          {...fieldSet}
          questions={questions?.filter(
            (question) =>
              question?.selfIdType !== "DESCRIPTION" && question?.enabled,
          )}
          isRequired={section.isRequired}
        />
      </SelfApplySectionContainer.Content>
    </SelfApplySectionContainer.Container>
  ) : (
    <div />
  );
};
